(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["basz-product-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('basz-product-details')) {
    customElements.define('basz-product-details', class extends HTMLElement {
      connectedCallback() {
        this.setVariant(this.dataset.variantId);
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeVariant?.();
          this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (String(data.sectionId) !== this.dataset.sectionId || !data.variant) return;
            this.setVariant(data.variant.id);
          });
        }
      }
      setVariant(id) {
        const blocks = Array.from(this.querySelectorAll('[data-basz-variant]'));
        if (!blocks.some((block) => block.dataset.baszVariant === String(id))) return;
        blocks.forEach((block) => block.toggleAttribute('data-basz-active', block.dataset.baszVariant === String(id)));
        this.dataset.variantId = String(id);
      }
      disconnectedCallback() {
        this.unsubscribeVariant?.();
        this.unsubscribeVariant = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
